var map = {
	"./btn/home.jpg": "j6J3",
	"./btn/home1.jpg": "o2yq",
	"./btn/top.jpg": "IZPr",
	"./btn/top1.jpg": "IVS3",
	"./circle_email.gif": "tr+Q",
	"./circle_phone.gif": "nyoB",
	"./circle_support.gif": "P/f8",
	"./company-contact-bg.png": "ptLF",
	"./company-content-img.png": "j6Fh",
	"./company-content-img1.png": "EI/A",
	"./company-content-img2.png": "BjPm",
	"./company-content-img3.png": "qwnl",
	"./company-content-img4.png": "XOTM",
	"./company-content-swiper-next.png": "978+",
	"./company-content-swiper-prev.png": "0ynV",
	"./company-content-title-ico.png": "HXgj",
	"./company-specialty-bg.png": "Cebt",
	"./company-specialty-img-1.png": "qtuN",
	"./company_header_bg.png": "zv7m",
	"./companys/cc.jpg": "AOgg",
	"./companys/dongfeng.jpg": "G1vG",
	"./companys/faurecia.png": "vX8W",
	"./companys/garrett.png": "jUSt",
	"./companys/hbrdt.png": "BqhB",
	"./companys/mahle.png": "j70Q",
	"./companys/ofu.jpg": "9s3F",
	"./companys/pangood.png": "09DG",
	"./companys/plastic.png": "08tn",
	"./companys/tenneco.png": "lCbN",
	"./companys/tpi.png": "Co48",
	"./companys/tpicomposites.png": "5dSH",
	"./conference.gif": "AQBT",
	"./contact-address-title-bg.png": "zmS6",
	"./contact-address-title-ico.png": "3p9m",
	"./contact-advisory-contact-bg.png": "PSwf",
	"./contact-advisory-guanzhu.png": "3sdE",
	"./contact-advisory-phone.png": "tDoF",
	"./contact-advisory-weixin.png": "liOl",
	"./contact-feedback-bg.png": "7GBb",
	"./dot_28.png": "Lhs1",
	"./down.png": "rix4",
	"./email.gif": "ioL8",
	"./function/funs.png": "Apt6",
	"./function/stop1.jpg": "os+E",
	"./function/stop2.jpg": "yqSM",
	"./home-example-bg.png": "9kgm",
	"./home-example-left.png": "iyvd",
	"./home-example-logo.png": "Qnz8",
	"./home-example-right.png": "OZ83",
	"./home-footer.png": "tGgA",
	"./home-header-advan_1.png": "cEiu",
	"./home-header-advan_2.png": "PoZM",
	"./home-header-advan_3.png": "LpFQ",
	"./home-header-advan_4.png": "2HKe",
	"./home-header-advan_5.png": "oRcq",
	"./home-header-advan_6.png": "plJM",
	"./home-header-advan_7.png": "+gFK",
	"./home-header-advan_8.png": "ArTJ",
	"./home-header-top.png": "V8Q3",
	"./home-joinus-appqr.png": "NEii",
	"./home-joinus-bg.png": "U+rK",
	"./home-joinus-weixinqr.png": "EGKg",
	"./home-logo.png": "iEsh",
	"./home-phone_ad.png": "aJfm",
	"./home-products_logo.png": "1w8e",
	"./icon/icon_android.png": "SJC9",
	"./icon/icon_companyLogo.png": "ocE6",
	"./icon/icon_ios.png": "c+F8",
	"./icon/icon_windows.png": "6vxO",
	"./imgqr/appstroe_android.png": "HFeZ",
	"./imgqr/download_android.png": "yRJk",
	"./imgqr/icon_weixin_gzh_qr.png": "Qi8m",
	"./imgqr/icon_weixin_joinus_qr.png": "VwNO",
	"./imgqr/qrcode_ios.png": "Gbwa",
	"./logo_icon.png": "Gz/r",
	"./mes.png": "Xm3Y",
	"./module-header-img.png": "hqXa",
	"./module-stop-footerimg_1.png": "76b0",
	"./module-stop-footerimg_2.png": "DAEt",
	"./module-stop-footerimg_3.png": "IJ97",
	"./module-stop-footerimg_5.png": "ffiG",
	"./module-stop-title_bg.png": "yIGW",
	"./module-stop-topimg_1.png": "gLpy",
	"./module-stop-topimg_2.png": "nKco",
	"./module-stop-topimg_3.png": "5uRr",
	"./module-stop-topimg_4.png": "n7Ro",
	"./module-stop-topimg_5.png": "b094",
	"./module/000_tv0.png": "hu9/",
	"./module/000_tv1.png": "apT1",
	"./module/001_m.png": "H9Dj",
	"./module/002_m.png": "NTuA",
	"./module/002_tv.png": "6Jn4",
	"./module/003_tv0.png": "uGZv",
	"./module/003_tv1.png": "31gb",
	"./module/004_m.png": "Ficy",
	"./module/005_m.png": "nuuB",
	"./module/005_tv0.png": "Egjo",
	"./module/005_tv1.png": "1VCu",
	"./module/005_tv2.png": "Q8gW",
	"./module/006_m.png": "gRnJ",
	"./module/006_tv0.png": "XVKD",
	"./module/007_m.png": "sxi8",
	"./module/008_m.png": "vDf4",
	"./module/008_tv0.png": "XKaK",
	"./module/009_m.png": "m77j",
	"./module/009_tv0.png": "KNXG",
	"./module/010_m0.png": "PHnh",
	"./module/010_tv0.png": "SOSn",
	"./module/011_m0.png": "JcvA",
	"./module/012_m0.png": "pfaE",
	"./module/012_tv0.png": "MRGK",
	"./module/013_m0.png": "4bVb",
	"./module/013_tv0.png": "dp4M",
	"./module/014_m0.png": "jnc7",
	"./module/015_m0.png": "CCoW",
	"./module/016_m0.png": "CYzW",
	"./module/016_tv0.png": "JbgR",
	"./module/017_m0.png": "EAcq",
	"./module/018_m0.png": "juhB",
	"./module/018_tv0.png": "o1BN",
	"./module/019_m0.png": "j3hs",
	"./module/019_tv0.png": "h9nu",
	"./module/020_m0.png": "lzNd",
	"./module/020_tv0.png": "qQNE",
	"./module/021_m0.png": "r/eQ",
	"./module/021_tv0.png": "jyBY",
	"./module/021_tv1.png": "jfUB",
	"./module/022_m0.png": "L4P3",
	"./module/andon_home.png": "T9fD",
	"./module/andon_tv.png": "Z3AC",
	"./pad.gif": "w6fX",
	"./phone.gif": "M1jA",
	"./product_image0.png": "yImF",
	"./product_image1.png": "XCtJ",
	"./product_image2.png": "Epra",
	"./product_image3.png": "XHBL",
	"./product_image4.png": "2ahv",
	"./solution-content-ico_1.png": "4XHV",
	"./solution-content-ico_2.png": "8D/C",
	"./solution-content-ico_3.png": "Wik/",
	"./solution-content-ico_4.png": "1IA9",
	"./solution-content-ico_5.png": "J4H4",
	"./solution-content-ico_6.png": "Awbr",
	"./solution-content-img.png": "9liA",
	"./solution-header-bg.png": "94cW",
	"./solution/solution1.png": "76zL",
	"./solution/solution2.png": "rW9i",
	"./solution/solution3.png": "Q7vC",
	"./solution/solution4.png": "Qkja",
	"./solution/solution_cloud.jpg": "LWed",
	"./solution/solution_local.jpg": "FpmH",
	"./solution/solution_set.jpg": "DlfJ",
	"./solution_hardware.png": "x+Ft",
	"./solution_six.png": "C9sw",
	"./support.gif": "VYhV",
	"./support_.jpg": "wvOm",
	"./title.png": "Cb4U",
	"./tv.gif": "GDH8",
	"./web/web1.png": "r2RW",
	"./web/web10.png": "8Stj",
	"./web/web11.png": "zOEp",
	"./web/web12.png": "Qcda",
	"./web/web13.png": "nR/8",
	"./web/web2.png": "svVf",
	"./web/web3.png": "UJYd",
	"./web/web4.png": "E+HY",
	"./web/web5.png": "N5xG",
	"./web/web6.png": "P4QY",
	"./web/web7.png": "XCiv",
	"./web/web8.png": "2FOK",
	"./web/web9.png": "ppG7",
	"./youjiantou.png": "FAuW",
	"./zuojiantou.png": "QZo/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0